export default __webpack_public_path__ + "static/media/drawing-man7-focusfill.a6a74f27.svg";